import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import LoaderView from "../views/Loader.vue";
import LayoutWizardView from "../views/LayoutWizard.vue";
import { $store } from "@/store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/:id",
    name: "loader",
    component: LoaderView,
  },
  {
    path: "/layout_wizard/:id",
    name: "layout_wizard",
    component: LayoutWizardView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!$store.wizard.ready && to.name != "loader") {
    next({ name: "loader", params: to.params });
  } else {
    next();
  }
});

export default router;
